const buildAccounts = (channel, accounts) => {
  const {
    system_name: systemName,
    name: channelName,
    color: channelColor,
    id: channelId,
  } = channel

  const channelAccounts = accounts.filter((a) => {
    if (!a.service) return false

    return a.service.id === channel.id
  })

  const mappableAccounts = channelAccounts.map
    ? channelAccounts
    : Object.values(accounts)

  return [
    {
      id: `service-${channelId}`,
      title: `Any ${channelName} account`,
      color: channelColor,
      icon: `channel-${systemName}-14`,
      payload: {
        type_key: 'services_and_accounts',
        object: {
          id: systemName,
          _id: channelId,
        },
      },
    },
  ].concat(
    mappableAccounts.map((account) => {
      const { name: accountName, id: accountId } = account

      return {
        id: `account-${accountId}`,
        title: accountName,
        color: channelColor,
        icon: `channel-${systemName}-14`,
        payload: {
          type_key: 'services_and_accounts',
          object: {
            id: accountId,
            service_id: channelId,
          },
        },
      }
    })
  )
}

const buildChannels = ({ accounts = [], services = [] }) => {
  const mappableAccounts = accounts.map ? accounts : Object.values(accounts)
  const channelsFromAccounts = mappableAccounts
    .map((a) => a.service)
    .filter((c) => Boolean(c))
  const channels = [...channelsFromAccounts, ...services]
  const uniqChannels = channels.filter(
    (channel, pos, arr) =>
      arr.map((mapChannel) => mapChannel.id).indexOf(channel.id) === pos
  )

  return uniqChannels.map((channel) => {
    const { id, name, system_name, color } = channel

    return {
      id: `channel-${id}`,
      title: name,
      icon: `channel-${system_name}-14`,
      color,
      childOptions: buildAccounts(channel, accounts),
    }
  })
}

const buildChannelAccountFilters = ({ accounts = [], services = [] }) => ({
  id: 'channels-and-accounts',
  title: 'Channels & accounts',
  icon: 'channel-facebook-14',
  childOptions: buildChannels({ accounts, services }),
})

export default buildChannelAccountFilters
